var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E4EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0629 26.9441C33.6488 27.5301 33.6488 28.4816 33.0629 29.0676L25.5629 36.5676C24.977 37.1535 24.0254 37.1535 23.4395 36.5676C22.8535 35.9816 22.8535 35.0301 23.4395 34.4441L29.8801 28.0035L23.4441 21.5629C22.8582 20.977 22.8582 20.0254 23.4441 19.4395C24.0301 18.8535 24.9816 18.8535 25.5676 19.4395L33.0676 26.9395L33.0629 26.9441Z",
    fill: "#2D65F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/next_button.cbb1deba82b0a38a76ab94a8bf96efea.svg";
export { ForwardRef as ReactComponent };